export type Level = 'primary' | 'secondary' | 'success' | 'danger'
export class LevelValues {
  static PRIMARY: Level = 'primary'
  static SECONDARY: Level = 'secondary'
  static SUCCESS: Level = 'success'
  static DANGER: Level = 'danger'
}

export type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl'
export class SizeValues {
  static XS: Size = 'xs'
  static SM: Size = 'sm'
  static MD: Size = 'md'
  static LG: Size = 'lg'
  static XL: Size = 'xl'
}
